module.exports = __webpack_public_path__ + "img/1773.dbf0cc6a.jpg";